export default __webpack_public_path__ + "static/media/loginContent.04717432.png";